(function($) {
	$(document).ready(function() {
        initialise();
    });

    function initialise() {
        // GPDR cookie popup
        // ----------
        var gpdr_cookie = getCookie("gdpr-agreement");
        var gpdr_date_changed = new Date(2022, 06, 01);
        var gpdr_max_date = gpdr_date_changed.setYear(gpdr_date_changed.getFullYear() + 1);
        var gpdr_current_date = !Date.now ? 0 : Date.now();

        if(gpdr_cookie == null && gpdr_max_date >= gpdr_current_date) {
            $(".gpdr-agreement").removeClass("gpdr-hide");

            $(".gpdr-agreement > a").bind("click", function(e) {
                e.preventDefault();
                $(".gpdr-agreement").addClass("gpdr-hide");
                setCookie("gdpr-agreement", 1, 360);
            });
        }

        if($(".main-section").length > 0 && $(window).width() >= 767) {
            $(window).on('scroll', function() {
                if($(window).scrollTop() === 0) {
                    $('.bigger-logo').removeClass('hidden').addClass('shown');
                    $('.smaller-logo').addClass('hidden').removeClass('shown');
                }
                else {
                    $('.bigger-logo').removeClass('shown').addClass('hidden');
                    $('.smaller-logo').addClass('shown').removeClass('hidden');
                }
            });
        }

        if($('.form-footer-newsletter').length > 0) {
            $('.form-footer-newsletter').on('submit', subscribeToNewsletter);
        }

        if($('.slides-container').length > 0) {
            $('.slides-container').slick({
                mobileFirst: true,
                arrows: false,
                centerMode: true,
                centerPadding: '50px',
                slidesToShow: 1,
                prevArrow: '<button type="button" class="slick-prev dashicons dashicons-arrow-left-alt2"><span class="hidden">Précédent</span></button>',
                nextArrow: '<button type="button" class="slick-next dashicons dashicons-arrow-right-alt2"><span class="hidden">Suivant</span></button>',
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                          arrows: true,
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            arrows: true,
                            slidesToShow: 3,
                        }
                    },
                  ]
            });
        }

        initLeonardGTMTracking();
    }

    function subscribeToNewsletter(event){
        var email = $('.form-footer-newsletter input[type="email"]').val();

        event.preventDefault();
      
        if(email != ''){
          $.ajax({
            url: ElementorProFrontendConfig.ajaxurl,
            type: 'post',
            data: {
              action: 'erabliere_newsletter_subscribe',
              email: email,
            },
            beforeSend: function () {
                $('.newsletter-footer-form-error').addClass('hidden');
                $('.newsletter-footer-form-success').addClass('hidden');
            },
            success: function (result) {
              var response = JSON.parse(result);

              if(response.error == true) {
                $('.newsletter-footer-form-error').removeClass('hidden');
              }
              else {
                $('.newsletter-footer-form-success').removeClass('hidden');
              }

              $('.form-footer-newsletter input[type="email"]').val('');
            },
          });
        }
    }

    function sameHeight($objects) {
        $(window).bind("resize", {cachedObjects: $objects}, function(e) {
            var $cachedObjects = e.data.cachedObjects;
            sameHeightSet($cachedObjects);
        }).trigger("resize");
    }

    function sameHeightSet($cachedObjects) {
        var max = -1;
        var h = 0;

        $cachedObjects.css({minHeight: 0});
        $cachedObjects.each(function() {
            h = $(this).height();
            max = h > max ? h : max;
        });

        $cachedObjects.each(function() {
            $(this).css({minHeight: max});
        });
    }

    // Set cookie information
    //
    // @return Void
    function setCookie(cookie_name, value, expiration_days) {
        var expiration_date = new Date();
        expiration_date.setDate(expiration_date.getDate() + expiration_days);

        var cookie_value = escape(value) + ((expiration_days == null) ? "" : "; expires=" + expiration_date.toUTCString())+"; path=/";
        document.cookie = cookie_name + "=" + cookie_value;
    }

    // Get cookie information
    //
    // @return String || undefined
    function getCookie(cookie_name) {
        var cookie_value = document.cookie;
        var cookie_start = cookie_value.indexOf(" " + cookie_name + "=");

        if (cookie_start == -1) cookie_start = cookie_value.indexOf(cookie_name + "=");

        if (cookie_start == -1) {
        cookie_value = null;
        }else{
        cookie_start = cookie_value.indexOf("=", cookie_start) + 1;
        var c_end = cookie_value.indexOf(";", cookie_start);

        if (c_end == -1) c_end = cookie_value.length;

        cookie_value = unescape(cookie_value.substring(cookie_start,c_end));
        }

        return cookie_value;
    }

    function initLeonardGTMTracking() {
        var arrLeonardGTMTrackingFormPath = [
            "/contact/",
            "/demande-de-reservation-en-ligne/",
            "/en/contact/",
            "/en/online-reservation-request/"
        ];
        var arrLeonardGTMTrackingCTA = [];
        
        for (var i = 0; i < arrLeonardGTMTrackingFormPath.length; i++) {
            arrLeonardGTMTrackingCTA.push("a.btn[href*='" + arrLeonardGTMTrackingFormPath[i] + "'], a.button[href*='" + arrLeonardGTMTrackingFormPath[i] + "'], a[href*='" + arrLeonardGTMTrackingFormPath[i] + "']");
        }
    
        // Custom CSS rules here
        // arrLeonardGTMTrackingCTA.push(".custom-rule-for-CTA-pointing-to-leads-form a");
    
        jQuery(arrLeonardGTMTrackingCTA.join(", ")).addClass("gtm-form-view");
    
        // Track «Leads form» submit button click
        // -------
        if (arrLeonardGTMTrackingFormPath.indexOf(window.location.pathname) != -1) {
            jQuery("form button, form input[type=submit]").addClass("gtm-form-submited");
        }
    
        // Custom CTA tracking here	
        // --------
        addGTMClass(jQuery('a[href*="https://panier.erabliere-cheminduroy.qc.ca/"]'), 'gtm-form-newsletter');

        addGTMClass(jQuery('a[href*="https://panier.erabliere-cheminduroy.qc.ca/"]'), 'gtm-cta-1');
        addGTMClass(jQuery('a[href*="/plats-cuisines-erabliere/"]'), 'gtm-cta-2');
        addGTMClass(jQuery('a[href*="/en/ready-cooked-meals/"]'), 'gtm-cta-2');
        addGTMClass(jQuery('a[href*="https://panier.erabliere-cheminduroy.qc.ca/"]'), 'gtm-cta-3');

        addGTMClass(jQuery('#breadcrumbs'), 'gtm-breadcrumbs');
        addGTMClass(jQuery('.elementor-tab-title'), 'gtm-accordion');
    }
    
    // Add gtm class dynamically
    function addGTMClass(element, gtmClass) {
        if (element.length) {
            element.addClass(gtmClass);
        }
    }
})(jQuery);